export default __webpack_public_path__ + "static/media/lush3.1658fff1.png";